__turbopack_context__.v({
  "blink": "Contact-module-scss-module__nhCVxa__blink",
  "blockNotes": "Contact-module-scss-module__nhCVxa__blockNotes",
  "career": "Contact-module-scss-module__nhCVxa__career",
  "careers": "Contact-module-scss-module__nhCVxa__careers",
  "contact": "Contact-module-scss-module__nhCVxa__contact",
  "description": "Contact-module-scss-module__nhCVxa__description",
  "descriptionTitle": "Contact-module-scss-module__nhCVxa__descriptionTitle",
  "top": "Contact-module-scss-module__nhCVxa__top",
  "topCareers": "Contact-module-scss-module__nhCVxa__topCareers",
  "topContent": "Contact-module-scss-module__nhCVxa__topContent",
});
